import type { ReactNode } from "react";
import { useLocation } from "react-router-dom";
import type { LocaleKey } from "../utils/svgPlaceholders";
import { useTranslation } from "react-i18next";

interface ColumnCenterProps {
  locale: LocaleKey;
  children: ReactNode;
  pageGraphic?: string;
  pageGraphicLabel?: string;
}

export const ColumnCenter = ({
  locale: _locale,
  children,
  pageGraphic,
  pageGraphicLabel,
}: ColumnCenterProps) => {
  const location = useLocation();
  const { t } = useTranslation();
  const isHome =
    location.pathname === "/" ||
    location.pathname === "" ||
    location.pathname === "/en/" ||
    location.pathname === "/en";

  const homeDescription: string[] = t("layout.descriptionParagraphs", {
    returnObjects: true,
  }) as string[];

  return (
    <div className="column-center">
      <div className="column-center__banner">
        <img
          src={
            isHome
              ? "/basiclaw2025-26/assets/home-top-banner.png"
              : "/basiclaw2025-26/assets/page-top-banner.png"
          }
          alt=""
        />
      </div>
      {isHome ? (
        <div className="column-center__home-description">
          {homeDescription.map((paragraph, index) => (
            <p
              key={`home-desc-${index}`}
              className={
                "column-left__description" +
                (index === 1 ? " column-left__description--inverse" : "")
              }
            >
              {paragraph}
            </p>
          ))}
        </div>
      ) : null}
      <div className="column-center__content">
        {!isHome && pageGraphic ? (
          <div className="column-center__page-title">
            <h1 className="column-center__page-title-heading">
              <span className="visually-hidden">{pageGraphicLabel ?? ""}</span>
              <img src={pageGraphic} alt="" aria-hidden="true" />
            </h1>
          </div>
        ) : null}
        {children}
      </div>
    </div>
  );
};
